const firestoreSystemUser = "system";

export default firestoreSystemUser;
